
import TaggerService from '@/api/tagger';
import StringToColor from '@/helper/colorHelper';

const suggestionsDefault = {
	query: '',
	suggestions: [],
};


export default {
	state: Object.assign({}, suggestionsDefault),

	mutations: {
		updateSuggestions(state, data) {
			// Adding button/pillcolor to the objects
			data.suggestions.suggestions = data.suggestions.suggestions.map(
				currentValue => (
					{ ...currentValue, color: StringToColor.colorstring(currentValue.S_Type) }
				),
			);
			state.query = data.query;
			state.suggestions = data.suggestions;
		},

		resetSuggestions(state) {
			state.query = '';
			state.suggestions = [];
		},
	},

	actions: {
		getCategorySuggestions({ commit }, query) {
			return new Promise((resolve, reject) => {
				TaggerService.getSuggestions(query, 'ATTRIBUT')
					.then((responseData) => {
						commit('updateSuggestions', {
							query,
							suggestions: responseData,
						});
						resolve();
					})
					.catch((e) => {
						reject(e);
					});
			});
		},

		resetSuggestions({ commit }) {
			commit('resetSuggestions');
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/modules/tagger.js